export default function formatNum(number) {
  let numberStr = String(number);
  if (!numberStr.includes(".")) {
    numberStr += "._";
  }
  return numberStr.replace(/(\d)(?=(\d{3})+\.)/g, "$1,").replace(/\._$/, "");
}
